let originalTitle = document.title;
const blinkTitle = document.querySelector(".ab_blink_meta_title").dataset.blink;
let blinkInterval;
let timeoutId;

const INACTIVITY_TIME = 120000;

document.addEventListener("visibilitychange", function () {
  if (document.hidden) {
    timeoutId = setTimeout(startBlinkingTitle, INACTIVITY_TIME);
  } else {
    stopBlinkingTitle();
  }
});

function startBlinkingTitle() {
  if (document.hidden) {
    blinkInterval = setInterval(() => {
      document.title =
        document.title === blinkTitle ? originalTitle : blinkTitle;
    }, 3000);
  }
}

function stopBlinkingTitle() {
  clearInterval(blinkInterval);
  clearTimeout(timeoutId);
  document.title = originalTitle;
}
